import { Disclosure } from "@headlessui/react";
import {
  ChevronDoubleDownIcon,
  ReceiptPercentIcon,
} from "@heroicons/react/24/solid";
import { useRecoilState } from "recoil";
import CloseIconButton from "../../../../../components/CloseIconButton";
import InvoiceItemizedView from "../../InvoiceCapture/view/InvoiceItemizedView";
import { SubmittedInvoiceActivityHistoryView } from "./SubmittedInvoiceActivityHistoryView";
import { SubmittedView } from "./SubmittedView";
import { VoidedView } from "./VoidedView";
import { submittedData } from "../atoms/atoms";
import { voidedData } from "../../InvoiceCapture/atoms/atoms";
import InvoiceDebitAdjustmentDetails from "../../InvoiceCapture/view/InvoiceDebitAdjustmentDetails";

interface SubmittedToAcumaticaDetailsProp {
  cancelShow;
  rowData;
  activityHistoryData;
}

export const SubmittedToAcumaticaDetails: React.FC<
  SubmittedToAcumaticaDetailsProp
> = ({ cancelShow, rowData, activityHistoryData }) => {
  const [submittedInvoiceDetails, setSubmittedInvoiceDetails] =
    useRecoilState<any>(submittedData);
  const [voidedInvoiceDetails, setVoidedInvoiceDetails] =
    useRecoilState<any>(voidedData);

  return (
    <>
      <div className="box-shadow p-4 border-quinary border-l-2 p-2">
        <div>
          <div className="relative -top-6 -right-4">
            <CloseIconButton
              onClick={() => {
                cancelShow();
                setSubmittedInvoiceDetails(undefined);
                setVoidedInvoiceDetails(undefined);
              }}
            />
          </div>
        </div>
        <div>
          <div>
            <div className="flex justify-between items-center border-secondary border-b-2 ">
              <div>
                <div className="flex gap-2 items-center py-2">
                  <div>
                    <ReceiptPercentIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
                  </div>
                  <div className="flex flex-col leading tight">
                    <h3 className="text-xs font-medium text-gray-500 ">
                      Vendor Invoice Processing
                    </h3>
                    <h1 className="mr-auto font-bold text-primary text-md uppercase pb-2">
                      Batch List - {rowData?.id}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-xs space-y-2 my-2">
              <div className="ml-auto py-2 flex rounded shadow-lg justify-between ">
                <div className="space-x-4 mr-6 self-center mx-2 text-pink-500 font-bold">
                  {rowData?.vendorName} - {rowData?.vendorCode}
                </div>
              </div>
            </div>
            <div className="w-full">
              <div className="mt-2 bg-white p-4 shadow-lg rounded-md ">
                <div className="text-quinary pb-4 font-bold ">
                  Vendor Information
                </div>
                <div className="grid grid-cols-3 items-center">
                  <div className="self-start">
                    <div className="expandedLabelVIP fontExpand ml-2">
                      {rowData?.vendorName}
                    </div>
                    <div>
                      <div className="expandedDataVIP fontExpand ml-2">
                        {rowData?.vendorCode}
                      </div>
                    </div>
                  </div>
                  <div className="self-start">
                    <div className="expandedLabelVIP fontExpand ml-2">
                      {rowData?.officeName}
                    </div>
                    <div className="expandedLabelVIP fontExpand ml-2">
                      {rowData?.officeStreet} {", "} {rowData?.officeCity}{" "}
                      {", "}
                      {rowData?.officeStateCode}
                    </div>
                    <div className="expandedLabelVIP fontExpand ml-2">
                      {rowData?.officeZipcode}
                    </div>
                  </div>
                  <div className="self-start">
                    <div className="expandedLabelVIP fontExpand ml-2">
                      Vendor ID: {rowData?.vendorCode}
                    </div>
                    <div className="expandedLabelVIP fontExpand ml-2">
                      Address Code: {rowData?.vendorCode}
                    </div>
                  </div>
                </div>
              </div>
              {submittedInvoiceDetails &&
                submittedInvoiceDetails?.map((data) => {
                  return (
                    <>
                      <div className=" mt-2 bg-white p-4 box-shadow rounded-md ">
                        <div className="flex flex-row justify-between">
                          <div className="font-bold text-quinary ">
                            Invoice Details{" "}
                            {submittedInvoiceDetails
                              ? submittedInvoiceDetails?.length + 1
                              : 1}{" "}
                            - Approved
                          </div>
                        </div>
                        <SubmittedView rowData={data} />
                      </div>
                    </>
                  );
                })}
            </div>

            <div className="w-full">
              {voidedInvoiceDetails &&
                voidedInvoiceDetails?.map((data, index) => {
                  return (
                    <>
                      <Disclosure>
                        {({ open }) => (
                          <>
                            <div className="mt-2 bg-white rounded-lg box-shadow">
                              <div className="flex flex-row justify-between">
                                <div className="text-quinary font-bold font-sans py-2 px-3">
                                  Invoice Details {index + 1} - Voided
                                </div>
                                <div>
                                  <Disclosure.Button className="disclosureBtn ml-2 justify-end">
                                    <ChevronDoubleDownIcon
                                      className={`${
                                        open ? "transform rotate-180" : ""
                                      }  text-gray-500 w-5 h-5 mr-4`}
                                    />
                                  </Disclosure.Button>
                                </div>
                              </div>
                              <Disclosure.Panel className="text-xxs">
                                <div className="">
                                  <VoidedView rowData={data} />
                                </div>
                              </Disclosure.Panel>
                            </div>
                          </>
                        )}
                      </Disclosure>
                    </>
                  );
                })}
            </div>
            {/* Debit Adjusment Section */}
            {submittedInvoiceDetails &&
            submittedInvoiceDetails[0]?.debitAdjBillRef?.length > 0 ? (
              <div className="w-full bg-white">
                {submittedInvoiceDetails &&
                  submittedInvoiceDetails?.map((data) => {
                    return (
                      <>
                        <Disclosure defaultOpen={true}>
                          {({ open }) => (
                            <>
                              <div className=" bg-white rounded-lg shadow-lg">
                                <div className="flex flex-row justify-between mt-2">
                                  <div className="text-pink-500 font-bold font-sans py-2 px-3">
                                    Debit Adjusment
                                  </div>
                                  <div>
                                    <Disclosure.Button className="disclosureBtn ml-2 justify-end">
                                      <div className="flex flex-row justify-end">
                                        <div className="flex flex-row mr-4">
                                          <label className="text-quinary font-bold font-sans mr-2">
                                            Bill Adjustment:
                                          </label>
                                          <div className="bg-gray-100 border-gray-100 rounded shadow-md">
                                            <label className="text-black font-bold font-sans ml-2 mr-2">
                                              $
                                              {data.billAdjustment.length > 0
                                                ? data.billAdjustment.reduce(
                                                    (bill, adj) => bill + adj,
                                                    0
                                                  )
                                                : data.billAdjustment[0]}
                                            </label>
                                          </div>
                                        </div>
                                        <ChevronDoubleDownIcon
                                          className={`${
                                            open ? "transform rotate-180" : ""
                                          }  text-gray-500 w-5 h-5 mr-4`}
                                        />
                                      </div>
                                    </Disclosure.Button>
                                  </div>
                                </div>
                                <Disclosure.Panel className="text-xxs">
                                  <InvoiceDebitAdjustmentDetails
                                    rowData={data?.debitAdjustmentDetails}
                                  />
                                </Disclosure.Panel>
                                <div className="flex flex-row justify-end py-2 px-3 mr-7">
                                  <div className="bg-gray-100 border-4 border-gray-100 rounded shadow-md">
                                    <label className="text-quinary font-bold font-sans ml-2 mr-2">
                                      Total Amount Paid:
                                    </label>
                                    <label className="text-black font-bold font-sans mr-2">
                                      {data.billAdjustment.length > 0
                                        ? "$" +
                                          (data.amountPaid -
                                            data.billAdjustment.reduce(
                                              (bill, adj) => bill + adj,
                                              0
                                            ))
                                        : "$"}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </Disclosure>
                      </>
                    );
                  })}
              </div>
            ) : (
              ""
            )}
            {/* Allocation Section */}
            <div className="w-full bg-white">
              {submittedInvoiceDetails &&
                submittedInvoiceDetails?.map((data) => {
                  return (
                    <>
                      <Disclosure defaultOpen={true}>
                        {({ open }) => (
                          <>
                            <div className=" bg-white rounded-lg shadow-lg">
                              <div className="flex flex-row justify-between mt-2">
                                <div className="text-quinary font-bold font-sans py-2 px-3">
                                  Allocation Section
                                </div>
                                <div>
                                  <Disclosure.Button className="disclosureBtn ml-2 justify-end">
                                    <ChevronDoubleDownIcon
                                      className={`${
                                        open ? "transform rotate-180" : ""
                                      }  text-gray-500 w-5 h-5 mr-4`}
                                    />
                                  </Disclosure.Button>
                                </div>
                              </div>
                              <Disclosure.Panel className="text-xxs">
                                <InvoiceItemizedView
                                  rowData={data?.itemizeDetails ?? []}
                                />
                              </Disclosure.Panel>
                            </div>
                          </>
                        )}
                      </Disclosure>
                    </>
                  );
                })}
            </div>
            <div className="w-full bg-white ">
              <Disclosure>
                {({ open }) => (
                  <>
                    <div className=" bg-white rounded-lg shadow-lg">
                      <div className="flex flex-row justify-between mt-2">
                        <div className="text-quinary font-bold font-sans py-2 px-3">
                          Activity History
                        </div>
                        <div>
                          <Disclosure.Button className="disclosureBtn ml-2 justify-end">
                            <ChevronDoubleDownIcon
                              className={`${
                                open ? "transform rotate-180" : ""
                              }  text-gray-500 w-5 h-5 mr-4`}
                            />
                          </Disclosure.Button>
                        </div>
                      </div>
                      <Disclosure.Panel className="text-xxs">
                        <SubmittedInvoiceActivityHistoryView
                          activityHistoryData={activityHistoryData}
                        />
                      </Disclosure.Panel>
                    </div>
                  </>
                )}
              </Disclosure>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
